function normalizeDelimitedTextareaInput(string: string): string {
  const untrimmedResult = string.replace(/[,\n\r\s\s+]+/g, ' ');
  const trimmedResult = untrimmedResult.trim();
  return trimmedResult;
}

export default normalizeDelimitedTextareaInput;
